const profiling = false

class BenchMark {
    constructor(name) {
        this.name = name;
        this.start;
    }
    startTimer() {
        if (profiling) {
            this.start = new Date().getTime();
        }
    }
    logEvent(eventName) {
        if (profiling) {
            console.log(this.name + "." + eventName + ":", new Date().getTime() - this.start, "ms")
        }
    }
    finishTimer() {
        if (profiling) {
            console.log(this.name + ":", new Date().getTime() - this.start, "ms")
        }
    }
}

export { BenchMark };